// Work media added from /admin lives in the Firestore "work" collection.
// The public site reads it over the REST API (plain fetch), so visitors don't
// download the Firestore SDK; only /admin loads that.
import { FIREBASE_PROJECT_ID } from "../firebase-config";

const URL = `https://firestore.googleapis.com/v1/projects/${FIREBASE_PROJECT_ID}/databases/(default)/documents/work?pageSize=300`;

export const parseWorkDocs = (docs = []) =>
  docs
    .map(({ name, fields: f }) => ({
      id: name.split("/").pop(),
      category: f.category?.stringValue,
      src: f.src?.stringValue,
      alt: f.alt?.stringValue || "",
      video: Boolean(f.video?.booleanValue),
      large: Boolean(f.large?.booleanValue), // spans two grid columns
      order: Number(f.order?.integerValue ?? f.order?.doubleValue ?? 0),
    }))
    .sort((a, b) => a.order - b.order);

// Fetched once per page load; Work and About share the same request
let request;
export const fetchWorkMedia = () =>
  (request ||= fetch(URL)
    .then((r) => (r.ok ? r.json() : {}))
    .then((json) => parseWorkDocs(json.documents))
    .catch(() => [])); // site still shows the static items
